// Card FX — vanilla ports of React Bits <BorderGlow/> + <TiltedCard/>.
// BorderGlow: pointer edge-proximity + angle drive a masked mesh-gradient ring
// (CSS does the drawing; JS only feeds --edge-proximity / --cursor-angle).
// TiltedCard: spring-lerped rotateX/Y + scale (settings softened for MZ:
// 6° amplitude, 1.03 scale — the original 14°/1.1 is too loud for the shell).
(function () {
  var STONE = '#B8AFA3';
  var POS = ['80% 55%', '69% 34%', '8% 6%', '41% 38%', '86% 85%', '82% 18%', '51% 4%'];
  var KEYS = ['--gradient-one', '--gradient-two', '--gradient-three', '--gradient-four', '--gradient-five', '--gradient-six', '--gradient-seven'];
  var MAP = [0, 1, 2, 0, 1, 2, 1];

  var glowEls = document.querySelectorAll('.card, .door, .dyad-node, .mu-card');
  Array.prototype.forEach.call(glowEls, function (el) {
    if (el.classList.contains('bgx')) return;
    el.classList.add('bgx');
    var span = document.createElement('span');
    span.className = 'edge-light';
    span.setAttribute('aria-hidden', 'true');
    el.appendChild(span);
    var cs = getComputedStyle(el);
    var accent = (cs.getPropertyValue('--accent') || STONE).trim() || STONE;
    var ink = (cs.getPropertyValue('--accent-ink') || '#6E6B77').trim() || '#6E6E77';
    var colors = [accent, ink, STONE];
    for (var i = 0; i < 7; i++) {
      el.style.setProperty(KEYS[i], 'radial-gradient(at ' + POS[i] + ', ' + colors[MAP[i]] + ' 0px, transparent 50%)');
    }
    el.style.setProperty('--gradient-base', 'linear-gradient(' + accent + ' 0 100%)');
    var bg = cs.backgroundColor;
    if (bg && bg !== 'rgba(0, 0, 0, 0)') el.style.setProperty('--card-bg', bg);

    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      var cx = r.width / 2, cy = r.height / 2;
      var dx = x - cx, dy = y - cy;
      var kx = dx !== 0 ? cx / Math.abs(dx) : Infinity;
      var ky = dy !== 0 ? cy / Math.abs(dy) : Infinity;
      var edge = Math.min(Math.max(1 / Math.min(kx, ky), 0), 1);
      var deg = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      if (deg < 0) deg += 360;
      el.style.setProperty('--edge-proximity', (edge * 100).toFixed(2));
      el.style.setProperty('--cursor-angle', deg.toFixed(2) + 'deg');
    });
  });

  // tilt
  var AMP = 6, SCALE = 1.03;
  var tilts = [];
  Array.prototype.forEach.call(document.querySelectorAll('.card, .door, .mu-card'), function (el) {
    var t = { el: el, trx: 0, try_: 0, ts: 1, rx: 0, ry: 0, s: 1, hov: false };
    el.addEventListener('pointerenter', function () { t.hov = true; t.ts = SCALE; });
    el.addEventListener('pointerleave', function () { t.hov = false; t.trx = 0; t.try_ = 0; t.ts = 1; });
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var ox = e.clientX - r.left - r.width / 2;
      var oy = e.clientY - r.top - r.height / 2;
      t.trx = (oy / (r.height / 2)) * -AMP;
      t.try_ = (ox / (r.width / 2)) * AMP;
    });
    tilts.push(t);
  });
  if (!tilts.length && !glowEls.length) return;

  var last = performance.now();
  (function frame(now) {
    requestAnimationFrame(frame);
    var dt = Math.min((now - (last || now)) / 1000, 0.05);
    last = now;
    var k = 1 - Math.exp(-dt * 10);
    for (var i = 0; i < tilts.length; i++) {
      var t = tilts[i];
      t.rx += (t.trx - t.rx) * k;
      t.ry += (t.try_ - t.ry) * k;
      t.s += (t.ts - t.s) * k;
      var idle = Math.abs(t.rx) < 0.02 && Math.abs(t.ry) < 0.02 && Math.abs(t.s - 1) < 0.002 && !t.hov;
      t.el.style.transform = idle ? '' :
        'perspective(60rem) translateY(' + (t.hov ? '-0.25rem' : '0') + ') rotateX(' + t.rx.toFixed(2) + 'deg) rotateY(' + t.ry.toFixed(2) + 'deg) scale(' + t.s.toFixed(3) + ')';
    }
  })(last);
})();
